import { Button, Typography, type ButtonProps } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';

import { AuthorizationTooltip } from '../tooltips/authorizationTooltip';

interface ButtonWithIconOwnProps {
  icon?: string | ReactNode;
  iconPosition?: 'left' | 'right';
  text: ReactNode;
  isAuthorized?: boolean;
  dataTestId?: string;
  textClassName?: string;
  disabledTooltip?: string;
}

type ButtonWithIconProps = ButtonWithIconOwnProps &
  Omit<ButtonProps, keyof ButtonWithIconOwnProps>;

const ButtonWithIcon = forwardRef<HTMLButtonElement, ButtonWithIconProps>(
  (props, ref) => {
    const {
      icon,
      text,
      dataTestId,
      className,
      textClassName,
      iconPosition = 'left',
      isAuthorized = true,
      disabledTooltip,
      disabled,
      ...rest
    } = props;

    const iconElement: ReactNode =
      typeof icon === 'string' ? <i className={icon} /> : icon;

    return (
      <AuthorizationTooltip
        isAuthorized={isAuthorized}
        title={disabled ? disabledTooltip : undefined}
      >
        <div>
          <Button
            ref={ref}
            size='small'
            className={className}
            disabled={!isAuthorized || disabled}
            data-testid={dataTestId}
            {...rest}
            startIcon={iconPosition === 'left' ? iconElement : undefined}
            endIcon={iconPosition === 'right' ? iconElement : undefined}
          >
            <Typography
              noWrap
              variant='button'
              className={textClassName}
              sx={{ color: 'currentcolor' }}
            >
              {text}
            </Typography>
          </Button>
        </div>
      </AuthorizationTooltip>
    );
  }
);

export { ButtonWithIcon };
